import * as types from "../actions/actionTypes";

const initialState = {
  columnSettings: {
    preTransactions: [],
    transactions: [],
    properties: [],
    leases: [],
    leaseEvents: {
      all: [],
      snoozed: [],
      ignored: [],
    },
  },
  filterSettings: [],
  pageSize: 10,
  userViewSettings: [],
  noticeDate : null
};

export default function userSettingsReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_COLUMN_SETTINGS: {
      const { data } = action.payload;

      return {
        ...state,
        columnSettings: data,
      };
    }

    case types.GET_COLUMN_SETTINGS_PRE_TRANSACTION_LIST: {
      const { data } = action.payload;

      return {
        ...state,
        columnSettings: {
          ...state.columnSettings,
          preTransactions: data,
        },
      };
    }

    case types.GET_COLUMN_SETTINGS_TRANSACTION_LIST: {
      const { data } = action.payload;

      return {
        ...state,
        columnSettings: {
          ...state.columnSettings,
          transactions: data,
        },
      };
    }

    case types.GET_COLUMN_SETTINGS_LEASE_EVENTS_LIST_ALL: {
      const { data } = action.payload;

      return {
        ...state,
        columnSettings: {
          ...state.columnSettings,
          leaseEvents: {
            ...state.columnSettings.leaseEvents,
            all: data,
          },
        },
      };
    }

    case types.GET_COLUMN_SETTINGS_SNOOZED_LEASE_EVENTS_LIST: {
      const { data } = action.payload;

      return {
        ...state,
        columnSettings: {
          ...state.columnSettings,
          leaseEvents: {
            ...state.columnSettings.leaseEvents,
            snoozed: data,
          },
        },
      };
    }

    case types.GET_COLUMN_SETTINGS_IGNORED_LEASE_EVENTS_LIST: {
      const { data } = action.payload;

      return {
        ...state,
        columnSettings: {
          ...state.columnSettings,
          leaseEvents: {
            ...state.columnSettings.leaseEvents,
            ignored: data,
          },
        },
      };
    }

    case types.GET_COLUMN_SETTINGS_LEASE_LIST: {
      const { data } = action.payload;

      return {
        ...state,
        columnSettings: {
          ...state.columnSettings,
          leases: data,
        },
      };
    }

    case types.GET_COLUMN_SETTINGS_PROPERTY_LIST: {
      const { data } = action.payload;

      return {
        ...state,
        columnSettings: {
          ...state.columnSettings,
          properties: data,
        },
      };
    }

    case types.GET_FILTER_SETTINGS: {
      const { data } = action.payload;

      return {
        ...state,
        filterSettings: data,
      };
    }

    case types.SET_FILTER_SETTINGS: {
      const data = JSON.parse(action.payload?.config.data);

      return {
        ...state,
        filterSettings: data,
      };
    }

    case types.GET_PAGE_SIZE: {
      const { data } = action.payload || {};
      return {
        ...state,
        pageSize: data,
      };
    }
    case types.GET_USER_VIEW_SETTINGS: {
      const { data } = action.payload || [];
      return {
        ...state,
        userViewSettings: data,
      };
    }

    case types.GET_NOTICE_DATE: {
      const { data } = action.payload || [];
      return {
        ...state,
        noticeDate : data,
      };
    }

    default:
      return state;
  }
}
